var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEritrea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 14.6196C14.6087 14.6196 4.69565 27.327 4.68628 27.3246C7.58165 30.2201 11.5817 32.011 16 32.011C24.8365 32.011 32 24.8475 32 16.011L14.6087 14.6196Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 16.0107C14.6087 16.0107 4.69565 4.6948 4.68628 4.69705C7.58165 1.80162 11.5817 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107H14.6087Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 4.69702C-1.56209 10.9454 -1.56209 21.0761 4.68628 27.3245C4.68584 27.3271 32 16.0108 32 16.0108L4.68628 4.69702Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34778 9.40184C5.27909 9.40184 2.78259 11.8984 2.78259 14.967V17.054C2.78259 20.1227 5.27916 22.6192 8.34778 22.6192C11.4164 22.6192 13.913 20.1226 13.913 17.054V14.967C13.913 11.8984 11.4165 9.40184 8.34778 9.40184ZM11.826 17.054C11.826 18.6085 10.8009 19.9279 9.39122 20.3722V18.0975L10.8677 16.621L9.39203 15.1453L9.39122 14.6202V13.9237H7.30434V16.0105L5.82884 17.486L7.30434 18.9614V20.3722C5.89466 19.9279 4.86953 18.6086 4.86953 17.0541V14.9672C4.86953 13.0492 6.42991 11.4889 8.34778 11.4889C10.2657 11.4889 11.826 13.0493 11.826 14.9672V17.054Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEritrea);
export default __webpack_public_path__ + "static/media/eritrea.8c199054.svg";
export { ForwardRef as ReactComponent };